import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, QrCode, Users } from "lucide-react";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#07111D] text-white">
      <div className="max-w-6xl mx-auto px-6 py-24 md:py-32">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#1E2D40] bg-[#101B28] px-4 py-1.5 text-xs uppercase tracking-[0.2em] text-[#94A3B8]"
             data-testid="home-badge">
          <Sparkles className="w-3.5 h-3.5 text-[#18BFFF]" />
          Elite Digital · Business Card Manager
        </div>

        <h1 className="mt-8 font-display text-5xl md:text-7xl font-bold tracking-tight leading-[1.05]" data-testid="home-title">
          Digital business cards<br />
          <span className="text-[#18BFFF]">that never expire.</span>
        </h1>

        <p className="mt-6 max-w-2xl text-lg md:text-xl text-[#94A3B8] leading-relaxed" data-testid="home-subtitle">
          Create, share and manage QR-linked business cards for your entire team.
          One dashboard, one link per person, instant vCard downloads.
        </p>

        <div className="mt-12 flex flex-wrap gap-4">
          <Link
            to="/login"
            data-testid="open-admin-dashboard-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-[#18BFFF] px-7 py-4 font-semibold text-[#07111D] hover:bg-[#4DD0FF] transition-colors shadow-[0_4px_30px_rgba(24,191,255,0.25)]"
          >
            Sign in to dashboard
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to="/card/ticket-003"
            data-testid="view-sample-card-btn"
            className="inline-flex items-center gap-2 rounded-full border border-[#1E2D40] bg-transparent px-7 py-4 font-semibold text-white hover:bg-[#162436] transition-colors"
          >
            View sample card
          </Link>
        </div>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: Users, title: "100 pre-seeded slots", desc: "Ticket-001 to Ticket-100. Ready to fill." },
            { icon: QrCode, title: "Instant QR sharing", desc: "Each card owns a unique QR & public link." },
            { icon: Sparkles, title: "vCard 3.0 exports", desc: "Save Contact button generates .vcf on the fly." },
          ].map((f, i) => (
        <div key={f.title} className="rounded-2xl border border-[#1E2D40] bg-[#101B28] p-6 hover:border-[#18BFFF]/40 transition-colors" data-testid={`home-feature-${i}`}>
              <f.icon className="w-6 h-6 text-[#18BFFF]" />
              <h3 className="mt-4 font-display text-xl font-semibold">{f.title}</h3>
              <p className="mt-2 text-sm text-[#94A3B8]">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
